import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, withKeys as _withKeys, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["name", "checked"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Error = _resolveComponent("Error")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
            'input-wrapper',
            'input-wrapper--radio',
            'input-wrapper--' + _ctx.name,
        ])
  }, [
    _createElementVNode("label", {
      class: _normalizeClass([_ctx.hasError ? 'has-error' : ''])
    }, [
      _createElementVNode("input", {
        type: "radio",
        name: _ctx.name,
        class: "visually-hidden",
        tabindex: "-1",
        checked: _ctx.checked,
        onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleChange && _ctx.handleChange(...args)))
      }, null, 40, _hoisted_1),
      _createElementVNode("div", {
        class: _normalizeClass([
                    'input__label',
                    'input__label--radio',
                    'input__label--' + _ctx.name,
                ]),
        tabindex: "0",
        role: "radio",
        onKeydown: [
          _cache[1] || (_cache[1] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.handleChange && _ctx.handleChange(...args)), ["prevent"]), ["enter"])),
          _cache[2] || (_cache[2] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.handleChange && _ctx.handleChange(...args)), ["prevent"]), ["space"]))
        ]
      }, _toDisplayString(_ctx.label), 35)
    ], 2),
    (_ctx.handlesError)
      ? (_openBlock(), _createBlock(_component_Error, {
          key: 0,
          name: _ctx.name
        }, null, 8, ["name"]))
      : _createCommentVNode("", true)
  ], 2))
}